import { MentionData } from '../consts';

/** Restores the original id from renderKey and strips internal recents fields. Non-recents pass through unchanged. */
export function toCleanMention(mention: MentionData): MentionData {
  if (!mention.renderKey && !mention.fromRecents) return mention;
  const { renderKey: _renderKey, fromRecents: _fromRecents, ...rest } = mention;
  return mention.renderKey ? { ...rest, id: mention.renderKey } : rest;
}
